import React, { Fragment } from 'react';
import { useTranslation } from '@c/Translations';
import {
  GATEWAY_TYPE_PAYPAL,
  GATEWAY_TYPE_SQUARE,
  GATEWAY_TYPE_STRIPE,
  GATEWAY_TYPE_WORLDPAY,
} from '@showclix-shared/Payment/constants/gatewayTypes';
import Email from '@v/member/components/Email';
import LocalizedAddress from '@v/member/components/LocalizedAddress';
import Phone from '@v/member/components/Phone';
import KioskDeliveryTitle from './KioskDeliveryTitle';
import { DELIVERY_TYPE_EMAIL } from '../reducers/delivery';

export const DeliveryMethod = ({
  deliveryOption,
  onDeliveryPhoneChange,
  onCountryCodeChange,
  onAddressChange,
  selected,
  phone,
  countryCode,
  address,
  isKioskMode,
  kioskCollectCustomerEmail,
  onEmailChange,
  onMobileFocus: onMobileFocusProp,
  onEmailFocus: onEmailFocusProp,
  email,
  singularDeliveryOption,
  gatewayType,
}) => {
  const { t } = useTranslation();

  const onMobileFocus = (e) => {
    onMobileFocusProp(e, t('checkout__phone'));
  };

  const onEmailFocus = (e) => {
    onEmailFocusProp(e, t('checkout__email_address'));
  };

  const isShowDeliveryAddress = (gatewayType) => {
    //null represents ShowclixCreditCard gateway type
    return (
      gatewayType !== null &&
      ![GATEWAY_TYPE_STRIPE, GATEWAY_TYPE_SQUARE, GATEWAY_TYPE_WORLDPAY, GATEWAY_TYPE_PAYPAL].includes(+gatewayType)
    );
  };

  if (!selected) {
    return null;
  }

  if (deliveryOption.method_name === 'Mobile') {
    return (
      <Fragment>
        {isKioskMode && singularDeliveryOption ? <KioskDeliveryTitle /> : ''}
        <div className="delivery__mobile__numbers">
          <div className="mobile-number">
            <div className="input__control__group">
              <Phone
                phone={phone}
                required={true}
                onPhoneChange={onDeliveryPhoneChange}
                onCountryCodeChange={onCountryCodeChange}
                focus={true}
                countryCode={countryCode}
                onFocus={onMobileFocus}
                autocomplete={!isKioskMode}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  } else if (isKioskMode && deliveryOption.method_name === 'Pickup' && singularDeliveryOption) {
    return <div className="delivery__option__empty-state">{t('checkout__tickets_available_at_will_call')}</div>;
  } else if (deliveryOption.method_name === 'Pickup') {
    return null;
  } else if (isKioskMode && singularDeliveryOption && deliveryOption.method_name === 'Online') {
    if (kioskCollectCustomerEmail) {
      if (!email) {
        return <div className="delivery__option__empty-state">{t('checkout__tickets_sent_via_email')}</div>;
      }
      return (
        <div className="delivery__option__empty-state">{t('checkout__tickets_sent_to_your_email', { email })}</div>
      );
    } else {
      return (
        <Fragment>
          <KioskDeliveryTitle />
          <Email email={email} onEmailChange={onEmailChange} required={true} onFocus={onEmailFocus} />
        </Fragment>
      );
    }
  } else if (deliveryOption.method_name === 'Mail') {
    if (isShowDeliveryAddress(gatewayType)) {
      return (
        <div>
          <LocalizedAddress {...address} onAddressChange={onAddressChange} header={t('checkout__delivery_address')} />
        </div>
      );
    }

    return null;
  } else if (isKioskMode && !kioskCollectCustomerEmail && deliveryOption.method_type === DELIVERY_TYPE_EMAIL) {
    return (
      <div className="delivery__mobile__numbers">
        <Email email={email} onEmailChange={onEmailChange} required={true} onFocus={onEmailFocus} />
      </div>
    );
  }

  return null;
};
